const en = {
  searchingFor: 'Searching for:',
};

const de = {
  searchingFor: 'Suche nach:',
};

const filterBar = { en, de };
export default filterBar;
